import React from 'react'
import MainUI from './presenter/ui/UI'
import TodoListApi from './infrastructure/api/Api';
import TodoListService from './usecase/Service';
import Handler from './presenter/handler/Handler';

export default function Todo001Component() {
  const api = TodoListApi();
  const service = TodoListService(api);
  const handler = Handler(service);
  
  return (
    <MainUI handler={handler} />
  )
}
 